import { Slider, InputNumber} from 'antd';
import { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import { Row, Col, Card, Space } from 'antd';

Array.prototype.groupBy = function (props) {
    var arr = this;
    var partialResult = {};
    
    arr.forEach(el=>{
    
        var grpObj = {};
        
        props.forEach(prop=>{
              grpObj[prop] = el[prop]
        });
        
        var key = JSON.stringify(grpObj);
        
        if(!partialResult[key]) partialResult[key] = [];
        
        partialResult[key].push(el);
        
    });
    
    var finalResult = Object.keys(partialResult).map(key=>{
       var keyObj = JSON.parse(key);
       keyObj.values = partialResult[key];
       return keyObj;
    })
    
    return finalResult;
 }

Array.prototype.groupBy = function (props) {

    var arr = this;
    var partialResult = {};
    
    arr.forEach(el=>{
    
        var grpObj = {};
        
        props.forEach(prop=>{
              grpObj[prop] = el[prop]
        });
        
        var key = JSON.stringify(grpObj);
        
        if(!partialResult[key]) partialResult[key] = [];
        
        partialResult[key].push(el);
        
    });
    
    var finalResult = Object.keys(partialResult).map(key=>{
       var keyObj = JSON.parse(key);
       keyObj.values = partialResult[key];
       return keyObj;
    })
    
    return finalResult;
 }

const SliderDate = (props) => {

    let dateArr = [];
    
    const [timeLength, setTimeLength] = useState(1);
    const [dateArrState, setDateArrState] = useState(null);
    const [selectedTimeFormat, setSelectedTimeFormat] = useState([]);
    const [current, setCurrent] = useState(0);

    const [playState, setPlay] = useState(false);
    const [icon, setIcon] = useState(<CaretRightOutlined />);

    const [seconds, setSeconds] = useState(0);
    const [intervalID, setIntervalID] = useState(null);

    useEffect(() => {
        setSelectedTimeFormat({"DMON":1,"DYEAR":2563});
    },[]);

    useEffect(() => {
        if(props.graphData){
            const nestedData = props.graphData.groupBy(['DMON','DYEAR']);
            nestedData.forEach(d => {
                dateArr.push({"DMON":d.DMON,"DYEAR":d.DYEAR});
            });
            setTimeLength(dateArr.length);
            setDateArrState(dateArr);
            setSelectedTimeFormat(dateArr[current]);
        }
        },[props.graphData, props.selectedYear]);
    
    useEffect(() => {
        if(current < timeLength - 1){
            setCurrent(current+1);
            setSelectedTimeFormat(dateArrState[current+1]);
        } else {
            setPlay(false);
            setIcon(<CaretRightOutlined />);
            clearInterval(intervalID);
        }
    },[seconds]);

    function onClick(play) {
        if(playState == false){
            setPlay(true);
            setIcon(<PauseOutlined />);
            const interval = setInterval(() => {
                setSeconds(seconds => seconds + 1);
              }, 500);
            setIntervalID(interval);
        } else {
            setPlay(false);
            setIcon(<CaretRightOutlined />);
            clearInterval(intervalID);
        }
      }

      function onChange (value){
        if(props.graphData){
            setCurrent(value);
            setSelectedTimeFormat(dateArrState[value]);
        }
      };

      function formatter(value) {
        if(props.graphData && dateArrState != null && dateArrState[value] != undefined){
            let data = 'เดือน '+dateArrState[value].DMON+', '+dateArrState[value].DYEAR;
            return `${data}`;
        }
      }
      
    if(selectedTimeFormat === undefined){
        setSelectedTimeFormat({"DMON":1,"DYEAR":2563});
    }

    props.onChange(selectedTimeFormat);

    return (
        <Row>
            < Col span={2}>
                <div>
                    <Button type="primary" shape="circle" icon={icon} onClick={onClick}/>
                </div>
            </Col>
            < Col span={21}>
                <div>
                    <Slider
                    defaultValue={0}
                    min={0}
                    max={timeLength-1}
                    onChange={onChange}
                    tipFormatter={formatter}
                    tooltipVisible={true}
                    value={current}
                    />
                </div>
            </Col>
        </Row>
    );
}
 
export default SliderDate;
  